import { Text } from '@makemydeal/dr-ui-bricks-components';
import styled from 'styled-components';

export const PaymentOptionsSectionContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
    background-color: ${({ theme }) => theme.uiBricks?.pageBackgroundColor || '#ffffff'};
    border: ${({ theme }) =>
        `1px solid ${theme.uiBricks?.tradeInSummaryTradeInVehicleVehicleInfoKbbTradeInAdvisorContainerBorderColor || '#d6d8db'}`};
    border-radius: 12px;
    padding: 16px 20px;
`;

export const SectionQuestion = styled(Text)`
    color: ${({ theme }) => theme.uiBricks?.headlineFontColor || '#000000'};
`;
